import script from "./ListarBrindes.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarBrindes.vue?vue&type=script&setup=true&lang=js"

import "./ListarBrindes.vue?vue&type=style&index=0&id=1379128a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1379128a"]])

export default __exports__